import Bloc from './Bloc.js';
import Types from './Types.js';

export default class GlobalIntVariable extends Bloc {

	constructor (src, ctx) {

		super("intfvar", src, ctx);
		this.f = (src, ins) => [src.master.getVariable(ins[0]), src.master.getVariable(ins[0]) !== undefined];
		this.types = [Types.string, Types.card];
	}
}